export const getters = {
    getPesquisaSatisfacao: state => state.pesquisaSatisfacao,
    getPesquisasSatisfacao: state => state.pesquisasSatisfacao,
    getModalCadastroPesquisaSatisfacao: state => state.modalCadastroPesquisaSatisfacao,
    getModalVisualizarPesquisaSatisfacao: state => state.modalVisualizarPesquisaSatisfacao,
    getModalExcluirPesquisaSatisfacao: state => state.modalExcluirPesquisaSatisfacao,
    getModalPesquisarPesquisaSatisfacao: state => state.modalPesquisarPesquisaSatisfacao,
    getModalFinalizarPesquisaSatisfacao: state => state.modalFinalizarPesquisaSatisfacao,
    getFormularioPesquisaSatisfacao: state => state.formularioPesquisaSatisfacao
}

export default {}